export default {
  SMILEZY: 'SMILEZY',
  DENTALSTACK: 'DENTALSTACK',
  ROUTETOSMILE: 'ROUTETOSMILE',
  CRAFTALIGN: 'CRAFTALIGN',
  SYNAPSE: 'SYNAPSE',
  CLEARCASTLE: 'CLEARCASTLE',
  SMILEXCEL: 'SMILEXCEL',
  AMEND: 'AMEND',
  AIIQALIGNER: 'AIIQALIGNER',
  CONFIDENTALIGNER: 'CONFIDENTALIGNER',
  ROUTETOSMILEVSP:'ROUTETOSMILEVSP',
}
